import React from "react";
import PropTypes from "prop-types";

export function SectionErrors({ errorMessage, section }) {
  return errorMessage
    .filter((e) => e.section === section)
    .map((e) => (
      <div key={e.id} className="text-center mt-3">
        <p className="text-danger fw-bold">*{e.message}</p>
      </div>
    ));
}

SectionErrors.propTypes = {
  errorMessage: PropTypes.array.isRequired,
  section: PropTypes.string.isRequired,
};
